/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelPartFilterType } from './parcelPartFilterType.model';


export interface ParcelFilterDto { 
    area?: Array<number>;
    barterConcernedSubjectId?: number;
    departmentId?: number;
    drupoz?: Array<number>;
    exceptLpisUserId?: number;
    exceptParcelIds?: Array<number>;
    limit?: number;
    lpisUserId?: number;
    newVersionOnly?: boolean;
    noLpisUser?: boolean;
    offset?: number;
    ownershipLists?: Array<number>;
    parcelGroups?: Array<number>;
    parcelIds?: Array<number>;
    parcelPartType?: Array<ParcelPartFilterType>;
    parcis?: string;
    searchOwnershipList?: string;
    searchSubject?: string;
    setSubjectIds?: Array<number>;
    setTenantSubjectIds?: Array<number>;
    sortDir?: string;
    sortedBy?: string;
    state?: Array<number>;
    subcontractConcerned?: boolean;
    subjectIds?: Array<number>;
    withPersonalDataOnly?: boolean;
}

